module.exports = __webpack_public_path__ + "img/source_sw-con01.72d2f8ac.png";